import { QuestionEvaluationModel } from 'core/models/elements/evaluations/questionEvaluation.abstract.model';

/**
 * @class Defines an evaluation of a paper question
 */
export class PaperEvaluationModel extends QuestionEvaluationModel {
  /**
   * @constructor Creates an instance of paper evaluation.
   * @param {paperQuestion} paperQuestion is the element to be evaluated.
   */
  constructor(paperQuestion) {
    super(paperQuestion);
  }
}
